import { PermissionCheckerService } from 'abp-ng2-module';
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot, CanActivate,
    CanActivateChild, Router, RouterStateSnapshot, UrlTree
} from '@angular/router';
import { DataService } from '@app/shared/common/auth/data.service';
import {
    AppRouteDecision,
    bestRouteTarget,
    decideAppRoute,
    ONBOARDING_PERMISSION,
    ONBOARDING_ROUTE,
    OnboardingRouteFacts,
} from '@app/shared/common/auth/onboarding-routing-policy';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { UrlHelper } from '@shared/helpers/UrlHelper';

@Injectable()
export class AppRouteGuard implements CanActivate, CanActivateChild {

    constructor(
        private _permissionChecker: PermissionCheckerService,
        private _router: Router,
        private _sessionService: AppSessionService,
        private _dataService: DataService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        let onboardingDecision: AppRouteDecision;

        if (state && UrlHelper.isInstallUrl(state.url)) {
            return true;
        }

        if (!this._sessionService.user) {
            this._router.navigate(['/account/login']);
            return false;
        }

        // Adaptive Onboarding (D-08): one policy, BEFORE the permission early return, so clients, pipeline, settings
        // and the old welcome no longer bypass it. Release gate: not for real new owners, and DEV only, until the
        // onboarding page has its exits and a sign-out (see the header of onboarding-routing-policy.ts)
        onboardingDecision =decideAppRoute(this.onboardingRouteFacts(state ? state.url : ''));
        if (onboardingDecision === 'onboarding') {
            return this._router.parseUrl(ONBOARDING_ROUTE);
        }
        if (onboardingDecision === 'best-route') {
            return this._router.parseUrl(bestRouteTarget(this._sessionService.tenant, () => this.selectBestRoute()));
        }

        if (!route.data || !route.data['permission']) {
            return true;
        }

        if (this._permissionChecker.isGranted(route.data['permission'])) {
            // When subscription is expired, allow navigation but show upgrade modal
            if (this._sessionService.tenant.isSubscriptionExpired) {
                setTimeout(() => { this._dataService.openUpgradeModal.next(true); }, 500);
            }
            return true;
        }

        this._router.navigate([this.selectBestRoute()]);
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.canActivate(route, state);
    }

    /**
     * Adaptive Onboarding (D-08): the facts the onboarding routing policy reads (shared with OnboardingRouteGuard),
     * including the in-memory deferral of the onboarding store-load-failure exit (the deferral contract).
     */
    onboardingRouteFacts(url: string): OnboardingRouteFacts {
        return {
            user: this._sessionService.user,
            tenant: this._sessionService.tenant,
            url: url,
            viewportWidth: window.innerWidth,
            canUseOnboarding: this._permissionChecker.isGranted(ONBOARDING_PERMISSION),
            onboardingDeferred: this._sessionService.onboardingDeferred,
        };
    }

    selectBestRoute(): string {
        let sliderState = JSON.parse(localStorage.getItem('sliderState'));

        if (!this._sessionService.user) {
            return '/account/login';
        }

        if (this._sessionService.tenant.isSubscriptionExpired) {
            return '/app/main/my-day';
        }

        if (this._permissionChecker.isGranted('Pages.Home')) {
            if (sliderState !== null && sliderState !== undefined && sliderState.length > 0) {
                let foundSlider = sliderState.find(slider => slider.sliderName === 'projects');
                if (foundSlider) {
                    return '/app/main/projects';
                } else {
                    return '/app/main/my-day';
                }
            } else {
                    return '/app/main/my-day';
            }
            // return '/app/main/my-day';
        }

        if (this._permissionChecker.isGranted('Pages.Home')) {
            if (window.innerWidth < AppConsts.mobileScreenWidth) {
                return '/app/mobile/my-day';
            }
            if (sliderState !== null && sliderState !== undefined && sliderState.length > 0) {
                let foundSlider = sliderState.find(slider => slider.sliderName === 'projects');
                if (foundSlider) {
                    return '/app/main/projects';
                } else {
                    return '/app/main/my-day';
                }
            } else {
                    return '/app/main/my-day';
            }
            // return '/app/main/my-day';
        }
        if (sliderState !== null && sliderState !== undefined && sliderState.length > 0) {
            let foundSlider = sliderState.find(slider => slider.sliderName === 'projects');
            if (foundSlider) {
                return '/app/main/projects';
            } else {
                return '/app/main/my-day';
            }
        } else {
                return '/app/main/my-day';
        }
        // return '/app/main/my-day';
    }
}
